<template>
    <div>
        <div v-show="!subscribed">
            <div class="field field--addons">
                <div :class="input_class">
                    <input class="input" type="email" placeholder="Email" v-model="email" @keyup.enter="subscribe" :disabled="loading">
                </div>
                <div class="control">
                    <button class="button" :class="{'button--loading': loading}" type="button" @click="subscribe">Submit</button>
                </div>
            </div>
            <p><small>Will be used in accordance with our <a href="/privacy-policy">Privacy Policy</a>.</small></p>
            <p v-show="error" class="help u-text-red">Uh oh! Something went wrong. Please try again.</p>
        </div>
        <p v-show="subscribed" class="footer__newsletter-thank-you">Thanks for signing up!</p>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                email: '',
                loading: false,
                subscribed: false,
                error: false
            };
        },
        props: {
            'input_class': {
                type: String,
                default: 'control'
            }
        },
        methods: {
            subscribe() {
                let vm = this;
                if (this.email !== '') {
                    vm.loading = true;
                    vm.error = false;

                    this.$http.post('/newsletter-subscribe', {email: this.email}).then(function (response) {
                        if (response.status === 200 && response.data === true) {
                            vm.subscribed = true;
                        } else {
                            vm.error = true;
                        }
                    }).catch(function () {
                        vm.error = true;
                    }).finally(function () {
                        vm.loading = false;
                    });
                }
            }
        }
    };
</script>
